import { useGetContextOrError } from '@/lib/hooks/use-get-context-or-error';

import { context } from './context';

export const useContext = () => useGetContextOrError(context, 'Footer Menu');
